import { isStringNumeric } from 'components/helpers/strings';

function formatRiskValue(value) {
  if (!value) return '';

  return isStringNumeric(value) ? value : String(value)[0].toUpperCase();
}

export { formatRiskValue };
